import logo from '../logo.png';
import { Outlet } from "react-router-dom";
import { NavigationComponent } from '../Components/Navigation/NavigationComponent';

import { ToastContainer } from "react-toastify";	
import "react-toastify/dist/ReactToastify.css";
import CookieConsent from "react-cookie-consent";

export function Layout() {
    return (        
        <>  
        <header className="sticky-top">     
            <nav className="navbar navbar-expand-lg modern-nav">
                <div className="container">
                    <a className="navbar-brand d-flex align-items-center" href="/">
                        <img src={logo} alt="Arcane Scale" width="160" height="60" className="me-2" />
                    </a>                
                    <NavigationComponent/> 
                </div>
            </nav>                        
        </header>     
        <ToastContainer 
            position="top-center" 
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />   
        <main className="flex-grow-1">
            <Outlet />
        </main>        
        <footer className="modern-footer mt-auto">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="footer-text">
                            © {new Date().getFullYear()} Arcane Scale LLC. All rights reserved.
                        </div>
                    </div>
                    <div className="col-md-3 text-md-center">
                        <div className="footer-text">
                            Enterprise Content Management
                        </div>
                    </div>
                    <div className="col-md-3 text-md-end">
                        <div className="footer-links">
                            <a href="/privacy-policy" className="footer-link me-3">Privacy Policy</a>
                            <a href="/terms-of-use" className="footer-link">Terms of Use</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        
        <CookieConsent
            location="bottom"
            buttonText="Accept All Cookies"
            declineButtonText="Decline"
            enableDeclineButton
            cookieName="arcane-ecm-cookie-consent"
            style={{
                background: "#2B373B",
                color: "#ffffff",
                fontSize: "14px",
                fontFamily: "inherit"
            }}
            buttonStyle={{
                color: "#ffffff",
                fontSize: "14px",
                background: "#007bff",
                border: "none",
                borderRadius: "4px",
                padding: "8px 16px",
                margin: "0 8px"
            }}
            declineButtonStyle={{
                color: "#ffffff",
                fontSize: "14px",
                background: "transparent",
                border: "1px solid #ffffff",
                borderRadius: "4px",
                padding: "8px 16px",
                margin: "0 8px"
            }}
            expires={365}
            onAccept={() => {
                console.log("Cookies accepted");
            }}
            onDecline={() => {
                console.log("Cookies declined");
            }}
        >
            This website uses cookies to enhance your experience, analyze site traffic, and provide personalized content. 
            By continuing to use this site, you consent to our use of cookies. 
            <span style={{ fontSize: "10px", marginLeft: "8px" }}>
                <a href="/privacy-policy" style={{ color: "#ffffff", textDecoration: "underline" }}>
                    Privacy Policy
                </a>
                {" | "}
                <a href="/terms-of-use" style={{ color: "#ffffff", textDecoration: "underline" }}>
                    Terms of Use
                </a>
            </span>
        </CookieConsent>
        </>        
    );
}